"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagnosticsKey = exports.DiagnosticsEvent = void 0;
var Timing_1 = require("./Timing");
var DiagnosticsEvent;
(function (DiagnosticsEvent) {
    DiagnosticsEvent["START"] = "start";
    DiagnosticsEvent["END"] = "end";
})(DiagnosticsEvent = exports.DiagnosticsEvent || (exports.DiagnosticsEvent = {}));
var DiagnosticsKey;
(function (DiagnosticsKey) {
    DiagnosticsKey["OVERALL"] = "overall";
    DiagnosticsKey["INITIALIZE"] = "initialize";
    DiagnosticsKey["INITIALIZE_WITH_DELTA"] = "initialize_with_delta";
})(DiagnosticsKey = exports.DiagnosticsKey || (exports.DiagnosticsKey = {}));
var Diagnostics = /** @class */ (function () {
    function Diagnostics(context) {
        this.context = context;
        this.markers = [];
        this.metadata = {};
    }
    Diagnostics.prototype.getMarkers = function () {
        return {
            context: this.context,
            markers: this.markers,
            metadata: this.metadata
        };
    };
    Diagnostics.prototype.addMetadata = function (key, value) {
        this.metadata[key] = value;
    };
    Diagnostics.prototype.mark = function (key, action, step, value) {
        if (step === void 0) { step = null; }
        if (value === void 0) { value = null; }
        this.markers.push({
            key: key,
            step: step,
            action: action,
            value: value,
            timestamp: (0, Timing_1.now)(),
        });
    };
    return Diagnostics;
}());
exports.default = Diagnostics;
